import { render, staticRenderFns } from "./Configurations.vue?vue&type=template&id=cb18f580&scoped=true"
import script from "./Configurations.vue?vue&type=script&lang=js"
export * from "./Configurations.vue?vue&type=script&lang=js"
import style0 from "./Configurations.vue?vue&type=style&index=0&id=cb18f580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb18f580",
  null
  
)

export default component.exports